import {enumReduce, Values} from "@wix/devzai-utils-common";

export const BymoPageStyleScope = {
    Popup: 'popup',
    Document: 'document',
    PageContent: 'pageContent',
    Card: 'card'
} as const;

export type BymoPageStyleScope = Values<typeof BymoPageStyleScope>;

export const CustomizableBymoPageStyleScope = enumReduce(BymoPageStyleScope, [
    BymoPageStyleScope.PageContent,
    BymoPageStyleScope.Card,
    BymoPageStyleScope.Popup,
])

export type CustomizableBymoPageStyleScope = Values<typeof CustomizableBymoPageStyleScope>